import * as React from "react"
import {
  SaveResetButtons,
  SectionProps,
  UpdatableFormSectionRenderParams,
} from "./UpdateBookingWizard"
import {Form, Message, TextArea} from "semantic-ui-react"
import {BookingDriverState, BookingDriverUpdate, DriverUpdate} from "../graphql/queries"
import {GraphQL} from "../graphql"
import {errorUnionToEither} from "../graphql/errors"
import * as moment from "moment"

interface DriverSectionState {
  driverNotes: string
}

interface DriverSectionProps
  extends SectionProps,
    UpdatableFormSectionRenderParams<DriverSectionState> {}

export function DriverSection(props: DriverSectionProps) {
  const {
    modalStore,
    booking,
    state,
    mapState,
    disabled,
    setEditing,
    booker: {isAdmin},
  } = props
  const {driverNotes} = state
  const {isConfirmed, isComplete} = booking

  async function onSaveNotes() {
    return await modalStore.applyModal({
      pending: ["Saving booking notes", "Saving booking notes..."],
      error: (m) => ["Saving booking notes failed", m],
      action: async () => {
        return await onDriverUpdate({
          status: null,
          driverNotes,
        })
      },
    })
  }

  async function onCompleteBooking() {
    await modalStore.applyModal({
      pending: ["Completing booking", "Completing booking.."],
      error: (m) => ["Completing booking failed", m],
      action: async () => {
        const ret = await onDriverUpdate({
          status: BookingDriverState.Complete,
          driverNotes,
        })
        ret.map(() => {
          setEditing(false)
        })
        return ret
      },
    })
  }

  async function onConfirmBooking() {
    await modalStore.applyModal({
      pending: ["Confirming booking", "Confirming booking.."],
      error: (m) => ["Confirming booking failed", m],
      action: async () => {
        const ret = await onDriverUpdate({
          status: BookingDriverState.Confirmed,
          driverNotes,
        })
        ret.map(() => {
          setEditing(false)
        })
        return ret
      },
    })
  }

  async function onDriverUpdate(driverUpdate: DriverUpdate) {
    const data = await GraphQL.mutate(BookingDriverUpdate, {
      id: booking.id,
      driverUpdate,
    })
    return errorUnionToEither(data.bookingDriverUpdate)
  }

  const completeDisabled = !isAdmin && moment().isBefore(moment(booking.status.bookingTimestamp))

  return (
    <Form error>
      {isComplete ? (
        <Message positive content="Driver has completed this job." />
      ) : isConfirmed ? (
        <Message positive content="Driver has confirmed this job." />
      ) : (
        <Message error content="Driver has not confirmed this job." />
      )}
      <Form.Field>
        <label>Driver notes</label>
        {!mapState ? (
          driverNotes ? (
            <div style={{whiteSpace: "pre-wrap"}}>{driverNotes}</div>
          ) : (
            <i>None</i>
          )
        ) : (
          <TextArea
            // style={{fontSize: "small"}}
            autoHeight
            rows={4}
            placeholder="Driver Notes"
            value={driverNotes}
            onChange={(e, field) => {
              mapState((state) => {
                return {...state, driverNotes: (field.value || "").toString()}
              })
            }}
            disabled={disabled}
          />
        )}
      </Form.Field>
      {mapState ? (
        <Form.Group>
          {/* TODO Fix the order of the buttons ("Reset" should be to the right of Complete/Confirm) */}
          <SaveResetButtons
            {...props}
            onSave={async () => {
              return (await onSaveNotes()).isRight()
            }}
          />
          {isConfirmed &&
            !isComplete && (
              <Form.Button
                disabled={disabled || completeDisabled}
                color="blue"
                onClick={(e) => {
                  e.preventDefault()
                  modalStore.handlePromiseThrow(onCompleteBooking())
                }}
                content="Complete"
              />
            )}
          {!isConfirmed && (
            <Form.Button
              disabled={disabled}
              color="blue"
              onClick={(e) => {
                e.preventDefault()
                modalStore.handlePromiseThrow(onConfirmBooking())
              }}
              content="Confirm"
            />
          )}
        </Form.Group>
      ) : null}
    </Form>
  )
}



// WEBPACK FOOTER //
// ./src/components/BookingDriverSection.tsx